















































































































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { maskDate, maskHour, minutesToHours } from '@/utils/common'

@Component

export default class ComponenteBackofficeAgendamento extends Vue {
  $refs: {
    dtPicker: any,
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get timeLabel() {
    const tempo = this.getBackofficeGlobalStore.solicitacao.tempoCirurgia || 0
    if (tempo < 60) return `${tempo} minutos`
    return `${tempo} minutos / ${this.minutesToHoursUtil(this.getBackofficeGlobalStore.solicitacao.tempoCirurgia || 0)}`
  }

  get textFieldProps() {
    return this.textFieldProp
  }

  set textFieldProps(textFieldProp: any) {
    this.textFieldProp = textFieldProp
  }

  get datePickerProps() {
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      min: new Date(Date.now()).toISOString(),
    }
  }

  get timePickerProps() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      allowedMinutes: m => m % 15 === 0,
    }
  }

  textFieldProp: any = {
    appendIcon: 'event',
    errorMessages: '',
  }

  loading: boolean = false

  numeroReservaMessage: string = ''

  dataAgendamentoRadioGroup() {
    this.getBackofficeGlobalStore.dataAgendamentoRadioGroup()
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  formatHour(date: string) {
    return maskHour(date)
  }

  minutesToHoursUtil(value) {
    return minutesToHours(value)
  }

  async checkNumeroReserva(numeroReserva: string) {
    let isValid: boolean = true
    this.loading = true
    if (numeroReserva) {
      const params: any = {
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        numeroReserva,
        hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      }

      const response = await this.getBackofficeGlobalStore.getCheckNumeroReserva(params)

      if (response) {
        this.numeroReservaMessage = 'Número de reserva duplicado.'
      } else {
        this.numeroReservaMessage = ''
        isValid = false
      }
    } else {
      this.numeroReservaMessage = ''
    }

    this.loading = false
    return isValid
  }
}
